import dayjs from 'dayjs';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';
import { IIndicator } from 'app/shared/model/indicator.model';

export interface IIndicatorData {
  id?: number;
  created?: string | null;
  value?: number | null;
  truckImplement?: ITruckImplement | null;
  company?: ICompany | null;
  indicator?: IIndicator | null;
}

export const defaultValue: Readonly<IIndicatorData> = {};
